import { getHttpClient } from 'src/http-client';

interface Params {
  organizationName: string;
  projectId: string;
}

export async function getTagsService(params: Params) {
	try {
		const client = getHttpClient();
		const response = await client.get(`https://dev.azure.com/${params.organizationName}/${params.projectId}/_apis/wit/tags?api-version=6.0-preview.1`);
		
		if (response.status === 200) {
			return response.data.value;
		}

		return null;
	} catch (err) {
		return null;
	}
}